import { ISlugEntity } from '_/types/common.types';
import * as Yup from 'yup';

const slugPatternText = '^[a-z]([a-z0-9]|_[a-z0-9])*$';

const slugMaxLength = 126;

export const slugPattern = new RegExp(slugPatternText);

export const invalidSlugErrorMessage = `Slug must match pattern: ${slugPatternText}`;

export const validateSlug = (slug?: string): boolean =>
  slug
    ? slugPattern.test(slug)
    : // if slug is empty, no need to show regex validation
      true;

export const checkIfSlugExists = (slugEntities: ISlugEntity[], newSlug?: string): boolean =>
  !!slugEntities.find((item) => item.slug === newSlug);

const slugValidator = (slugEntities: ISlugEntity[], entityName: string): Yup.AnySchema =>
  Yup.string()
    .required('Slug is required.')
    .test('isSlugValid', (slug, { createError }) => validateSlug(slug) || createError({ message: invalidSlugErrorMessage }))
    .max(slugMaxLength, `Slug should be shorter than ${slugMaxLength} symbols.`)
    .test('isSlugUnique', (value, { createError }) =>
      checkIfSlugExists(slugEntities, value)
        ? createError({ message: `${entityName} with id/slug "${value}" already exists.` })
        : true,
    );

export default slugValidator;
